import { render, staticRenderFns } from "./bjgyfx.vue?vue&type=template&id=57261840&scoped=true&"
import script from "./bjgyfx.vue?vue&type=script&lang=js&"
export * from "./bjgyfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57261840",
  null
  
)

export default component.exports